export const popularBrands = [
  {
    href: "/brand/harley-davidson-rental",
    name: "Harley-Davidson"
  },
  {
    href: "/brand/bmw-rental",
    name: "BMW"
  },
  {
    href: "/brand/triumph-rental",
    name: "Triumph"
  },
  {
    href: "/brand/ducati-rental",
    name: "Ducati"
  },
  {
    href: "/brand/honda-rental",
    name: "Honda"
  },
  {
    href: "/brand/indian-rental",
    name: "Indian"
  }
]
